import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { TextColors } from '@picsart/design-system/foundation/colors';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';

const useStyles = createUseStyles(
  {
    message: {
      margin: 0,
      padding: [Spacings.s24, Spacings.s16],
      textAlign: 'center',
      color: TextColors.tint2,
      fontSize: FontSizes.t4,
      lineHeight: `${LineHeights.t4}px`,
    },
  },
  { name: 'search-body' }
);

export default useStyles;
